import { POST } from './Clients';

const ACCOUNTING_API_PREFIX = '/accounting/core/v1';
const PAYMENT_WALLET = '/payment/wallet/v1';

export async function getDebtCheck({ ctx, customerId }) {
  return POST({
    ctx,
    url: `${ACCOUNTING_API_PREFIX}/debt/check`,
    body: { customerId },
  });
}

export async function getListTransactions({ orderId, debug = false, status = null, moneySource = 'CREDIT', ctx, ...restProps }) {
  return POST({
    ctx,
    url: `${PAYMENT_WALLET}/me/transaction/list`,
    body: {
      q: {
        refAll: [`ORDER/${orderId}`],
        moneySource,
        status,
        ...restProps,
      },
      debug,
    },
  });
}
